module.exports = __webpack_public_path__ + "media/images/brand/logo-08-ad845291628d39fe3df5fd560ed56ff3.png";